import { useMachine } from '@xstate/react';
import React from 'react';
import {
  CalibrationMachineService,
  CalibrationMachineState,
  CalibrationStateMachine,
} from './calibrationMachine';

export type CalibrationMachineContextValue = {
  calibrationMachineState: CalibrationMachineState;
  calibrationMachineService: CalibrationMachineService;
};

type CalibrationProviderProps = {
  children: React.ReactNode;
  calibrationMachine: CalibrationStateMachine;
};

const CalibrationContext =
  React.createContext<CalibrationMachineContextValue | null>(null);

const CalibrationMachineProvider: React.FC<CalibrationProviderProps> = ({
  children,
  calibrationMachine,
}: CalibrationProviderProps) => {
  const [calibrationMachineState, , calibrationMachineService] =
    useMachine(calibrationMachine);

  return (
    <CalibrationContext.Provider
      value={{ calibrationMachineState, calibrationMachineService }}
    >
      {children}
    </CalibrationContext.Provider>
  );
};

export { CalibrationContext, CalibrationMachineProvider };
